module.exports = __webpack_public_path__ + "img/138.0d687984.jpg";